import { Component, OnInit, AfterViewInit  } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';


@Component({
  selector: 'app-myform',
  templateUrl: './myform.component.html',
  styleUrls: ['./myform.component.scss']
})
export class MyformComponent implements OnInit  {
  userId:any;
  orgId:any;
  ListOfFormNames:any[] = [];

  constructor(private http: Http,private router:Router,private route : ActivatedRoute) { }

  ngOnInit() {
   if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
        window.location.href = 'https://still.alshirawi.com/highmessaging/';
      } else {
        this.orgId=this.route.params['value'].orgId;
        this.userId=this.route.params['value'].userId;
        console.log('OrgId '+ this.orgId);
        console.log('UserId '+ this.userId);
      }

  }

  
  

  

  commonFormCall(formName, formId) {
    if(formName == 'Check List Master' || formName == 'CHECK LIST MASTER' || formName == 'check list master') {
      this.router.navigate(['checkListMaster',{Id: formId}]);
    } else if(formName == 'customer master' || formName == 'CUSTOMER MASTER' || formName == 'Customer Master') {
      this.router.navigate(['customerMaster',{Id: formId}]);
    } else if(formName == 'CHECK LIST DETAILS' || formName == 'Check List Details' || formName == 'check list details') {
      this.router.navigate(['checkListDetails',{Id: formId}]);
    } else if(formName == 'PREVENTIVE MAINTENANCE SERVICE CONTRACT' || formName == 'Preventive Maintenance Service Contract' || formName == 'preventive maintenance service contract') {
      this.router.navigate(['preventiveMaintenance',{Id: formId}]);
    }
  	
  }


  checkListMaster() {
    this.router.navigate(['node/checkListMaster']);
  }

  checkListDetails() {
    this.router.navigate(['node/checkListDetails']);
  }

  customerMaster() {
    this.router.navigate(['node/customerMaster']);
  }

  pmsc() {
    this.router.navigate(['node/preventiveMaintenance']);
  }

  service() {
    this.router.navigate(['node/serviceContract']);
  }

  postponed() {
    this.router.navigate(['node/postPonedForm']);
  }

  statusDueReport() {
    this.router.navigate(['node/ServiceDueReport']);
  }

  statusReportOneMonthBeforeReport() {
    this.router.navigate(['node/StatusReportOneMonthBefore']);
  }

  ThreeTimeOrMorePostPonedReport() {
    this.router.navigate(['node/ThreeTimeOrMorePostponementReport']);
  }

  InactiveCustomerreport() {
    this.router.navigate(['node/InactiveCustomerReport']);
  }

 // ngAfterViewInit(){
 //    // this.spinner.hide();
 //  } 


// }); 

}



// WEBPACK FOOTER //
// ./client/app/myform/myform.component.ts